import { h } from 'vue';
import render from './renders/component-lib.esm.js';
import Timeline from './component-lib.esm4.js';
import WithSeeMore from './component-lib.esm3.js';
const slot = (s, attrs) => {
  if (typeof s == 'function') return s(attrs);
  return s;
};
const wrapWithSeeMore = (storyNode, options, action) => {
  if (!options) return storyNode;
  const vnode = Array.isArray(storyNode) ? storyNode : {
    default: () => storyNode
  };
  const label = options === true ? undefined : options.label;
  return h(WithSeeMore, {
    props: {
      label
    },
    on: {
      action
    }
  }, vnode);
};
const fadeOut = el => {
  el.animate([
  // keyframes
  // { opacity: 1 },
  {
    opacity: 0
  }], {
    // options
    duration: 200,
    fill: 'forwards'
  });
};
const fadeIn = el => {
  el.animate([
  // keyframes
  //{ opacity: 0 },
  {
    opacity: 1
  }], {
    // options
    duration: 200,
    fill: 'forwards'
  });
};
const getX = e => {
  var _e$touches$;
  if (e instanceof MouseEvent) return e.offsetX;
  const touch = (_e$touches$ = e.touches[0]) !== null && _e$touches$ !== void 0 ? _e$touches$ : e.changedTouches[0];
  return touch.clientX;
};
var script = {
  name: 'Stories',
  props: {
    stories: {
      type: Array,
      required: true
    },
    interval: {
      type: Number,
      default: 2000
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    isPaused: {
      type: Boolean,
      required: false
    },
    loop: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['storyStart', 'storyEnd', 'allStoriesEnd', 'update:currentIndex', 'update:isPaused', 'seeMore'],
  watch: {
    currentIndex(val) {
      this.index = val;
    },
    isPaused: {
      immediate: true,
      handler(val) {
        this.paused = val;
      }
    },
    paused(val) {
      if (val) this.pause();else this.play();
      this.$emit('update:isPaused', val);
    },
    stories: {
      immediate: true,
      handler(val) {
        this.items = val.map(i => {
          let defaults = {
            duration: this.interval,
            type: 'image'
          };
          if (typeof i == 'string') return {
            ...defaults,
            url: i
          };else return {
            ...defaults,
            ...i
          };
        });
      }
    }
  },
  data() {
    return {
      index: this.currentIndex,
      paused: false,
      mouseDownTimeout: undefined,
      items: []
    };
  },
  methods: {
    nextSlide() {
      if (this.index < this.items.length - 1) {
        this.index++;
      } else if (this.loop) {
        this.index = 0;
      }
    },
    previousSlide() {
      if (this.index > 0) this.index--;else if (this.loop) this.index = this.items.length;
    },
    togglePause() {
      this.paused = !this.paused;
    },
    pause() {
      fadeOut(this.$refs.timeline.$el);
      if (this.$refs.header) fadeOut(this.$refs.header);
    },
    play() {
      fadeIn(this.$refs.timeline.$el);
      if (this.$refs.header) fadeIn(this.$refs.header);
    },
    storyStart(index) {
      this.$emit('storyStart', index);
      this.$emit('update:currentIndex', index);
    },
    storyEnd(index) {
      this.nextSlide();
      this.$emit('storyEnd', index);
    },
    allStoriesEnd() {
      if (this.loop) {
        this.index = 0;
      } else {
        this.$emit('allStoriesEnd');
      }
    }
  },
  render() {
    const story = this.items[this.index];
    const timelineProps = {
      props: {
        stories: this.items,
        currentIndex: this.index,
        isPaused: this.paused
      },
      on: {
        storyStart: this.storyStart,
        storyEnd: this.storyEnd,
        allStoriesEnd: this.allStoriesEnd
      }
    };

    // story
    const onAction = (action, data) => {
      switch (action) {
        case 'play':
          //this.paused = false
          //this.play()
          break;
        case 'pause':
          //this.paused = true
          //this.pause()
          break;
        case 'duration':
          this.items[this.index].duration = data;
          break;
        default:
          console.log(action, data);
      }
    };

    // stories event handlers
    const mouseDown = e => {
      e.preventDefault();
      this.mouseDownTimeout = setTimeout(() => this.togglePause(), 150);
    };
    const mouseUp = e => {
      e.preventDefault();
      this.mouseDownTimeout && clearTimeout(this.mouseDownTimeout);
      if (this.paused) this.paused = false;else {
        const x = getX(e);
        const {
          width
        } = this.$refs.stories.getBoundingClientRect();
        const t = width / 3;
        console.log(x, t);
        if (x > t) {
          this.nextSlide();
        } else {
          this.previousSlide();
        }
      }
    };
    const storiesEvents = {
      touchstart: mouseDown,
      touchend: mouseUp,
      mousedown: mouseDown,
      mouseup: mouseUp
    };
    const onSeeMore = () => {
      this.paused = true;
      this.$emit('seeMore', story);
    };
    const renderProps = {
      story,
      onAction,
      isPaused: this.paused
    };
    const header = this.$slots.header;
    const storyVnode = render(renderProps, this.$slots);
    return h('div', {
      ref: 'stories',
      class: 'vue-insta-stories',
      on: storiesEvents
    }, [h(Timeline, {
      ref: 'timeline',
      ...timelineProps
    }),
    //h('div', { class: 'timeline', ref: 'timeline' }, [h(Timeline, timelineProps)]),
    header ? h('div', {
      class: 'header',
      ref: 'header'
    }, slot(header, {
      story
    })) : null, wrapWithSeeMore(storyVnode, story.seeMore, onSeeMore)]);
  }
};
export { script as default };